<template>
	<div class="machine-user">
		<el-button
			type="primary"
			size="small"
			style="margin: 14px"
			@click="handlerUpload"
			>{{ $t("bouncer.upload") }}</el-button
		>

		<div class="table vue-padding radius">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				@selection-change="handleSelectionChange"
				:row-class-name="tableRowClassName"
				:data="appVersionList.records"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					:show-overflow-tooltip="true"
					:label="$t('upgrade.appName')"
					width="160"
					:align="'center'">
					<template #default> Reyeah Vending </template>
				</el-table-column>
				<el-table-column
					prop="appVersion"
					:label="$t('upgrade.appVer')"
					width="160"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="downUrl"
					:label="$t('addAppVersion.downUrl')"
					:show-overflow-tooltip="true"
					:align="'center'">
					<!-- <template #default="scope">
            <el-button size="small" type="primary">复制</el-button>
          </template> -->
				</el-table-column>
				<el-table-column
					prop="notes"
					:label="$t('iCard.notes')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="updateDate"
					:show-overflow-tooltip="true"
					width="180"
					:label="$t('upgrade.createTime')"
					:align="'center'"></el-table-column>

				<el-table-column
					fixed="right"
					:label="$t('common.edit')"
					:width="$i18n.locale == 'zh_CN' ? 196 : 250"
					:align="'center'">
					<template slot-scope="scope">
						<el-button type="text" @click="handlerCopy(scope.row)">{{
							$t("upgrade.copyUrl")
						}}</el-button>
						<el-button type="text" @click="handlerExit(scope.row)">{{
							$t("common.edit")
						}}</el-button>
						<el-button
							type="text"
							@click="handlerDownload(scope.row.downUrl)"
							>{{ $t("upgrade.down") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"
				@size-change="sizeChange"></el-pagination>
		</div>
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="buttonType == 1 ? $t('upgrade.uploadApp') : $t('upgrade.editApp')"
			:visible.sync="dialogVisibleUpLoad"
			width="30%"
			:before-close="handleClose">
			<el-form
				label-position="top"
				:model="insertAppInfo"
				:rules="rules"
				ref="ruleForm"
				label-width="100px"
				class="demo-ruleForm">
				<el-form-item :label="$t('upgrade.uploadApp')" prop="downUrl">
					<el-upload
						class="upload-demo"
						:action="appUploadUrl"
						:headers="headers"
						:on-success="appSuccess"
						:on-error="appError"
						:limit="1"
						:multiple="false"
						:accept="accept"
						:before-upload="handleBefore"
						:file-list="appFileList">
						<el-button slot="trigger" size="small" type="primary">{{
							$t("addAppVersion.trigger")
						}}</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item :label="$t('upgrade.appVersion')" prop="appVersion">
					<el-input
						v-model="insertAppInfo.appVersion"
						:placeholder="$t('upgrade.pAppVersion')"></el-input>
				</el-form-item>
				<el-form-item :label="$t('upgrade.notes')" prop="notes">
					<el-input type="textarea" :rows="4" v-model="insertAppInfo.notes">
					</el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleUpLoad = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="handlerAppInsert">{{
					$t("common.definite")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import config from "@/http/config";
export default {
	name: "AppList",
	components: {},
	data() {
		return {
			type: "",
			accept: ".apk",
			tempId: "",
			insertAppInfo: {
				type: "",
				appVersion: "",
				downUrl: "",
			},
			appUploadUrl: config.baseUrl + this.$url.Upload.app,
			headers: {
				token: this.$cookies.get("token"),
			},
			appFileList: [],
			buttonType: 1,
			dialogVisibleUpLoad: false,
			loading: false,
			machineGroup: [],
			appVersionList: [],
			page: {
				pageSize: 1,
				pageIndex: 1,
				totalSize: 0,
			},
			rules: {
				downUrl: [
					{
						required: true,
						message: this.$t("upgrade.pUpTrueFile"),
						trigger: "blur",
					},
				],
				appVersion: [
					{
						required: true,
						message: this.$t("upgrade.pAppVersion"),
						trigger: "blur",
					},
				],
			},
		};
	},
	mounted() {
		this.type = localStorage.getItem("wType") || "";
		this.currentChange();
		this.type == 5 ? (this.accept = ".apk") : (this.accept = ".ipa");
	},
	methods: {
		// 新增app
		handlerAppInsert() {
			// 循环验证版本号是否格式正确
			let tArr = this.insertAppInfo.appVersion;
			tArr = tArr.split("");
			tArr.forEach(item => {
				if (!(item === "." || (item < 10 && item >= 0))) {
					this.$message.warning(this.$t("upgrade.verError"));
					throw "格式不正确";
				}
			});
			this.insertAppInfo.type = this.type;
			let url = "";
			let methods = "";
			if (this.tempId) {
				this.insertAppInfo.id = this.tempId;
				url = this.$url.Upgrade.appExit;
				methods = this.$method.put;
			} else {
				url = this.$url.Upgrade.appInsert2;
				methods = this.$method.post;
			}
			this.$api.request(url, methods, this.insertAppInfo).then(res => {
				if (res.code === 0) {
					this.$message.success("上传成功");
					this.currentChange();
					this.dialogVisibleUpLoad = false;
				}
			});
		},
		appSuccess(res) {
			if (res.code === 0) {
				this.insertAppInfo.downUrl = res.data;
			} else {
				this.$message.error(res.msg);
			}
		},
		appError(err) {
			this.$message.error(err.msg ? err.msg : this.$t("addAppVersion.error"));
		},
		handlerDownload(url) {
			window.open(url, "_self");
		},
		handlerUpload() {
			this.buttonType = 1;
			this.clearInsert();
			this.tempId = "";
			this.dialogVisibleUpLoad = true;
		},
		clearInsert() {
			this.insertAppInfo = {
				type: "",
				appVersion: "",
				downUrl: "",
			};
			this.appFileList = [];
		},
		// 复制下载链接
		handlerCopy(row) {
			this.$tools.copy(row.downUrl);
		},
		// 编辑
		handlerExit(obj) {
			this.clearInsert();
			this.insertAppInfo.appVersion = obj.appVersion;
			this.insertAppInfo.downUrl = obj.downUrl;
			this.appFileList.push({
				name: "Reyeah Vending",
				url: obj.downUrl,
			});
			this.buttonType = 2;
			this.tempId = obj.id;
			this.dialogVisibleUpLoad = true;
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = {
				type: this.type,
				pageIndex: this.page.pageIndex,
			};
			this.$api
				.request(this.$url.Upgrade.appList, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.appVersionList = res.data;
						this.page.pageSize = +this.appVersionList.size;
						this.page.totalSize = +this.appVersionList.total;
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
	},
};
</script>

<style lang="scss" scoped>
.table {
	overflow: hidden;
}
.table .el-table .warning-row {
	background: #f56c6c;
	color: #ffffff;
}
.table .el-table .hover-row {
	color: #606266;
}
.machine-user .image {
	position: absolute;
}
.machine-user .maturity {
	color: #f56c6c;
}
.machine-user .renew {
	color: #67c23a;
}
.machine-user ::v-deep .el-dialog__body {
	height: auto;
}
</style>
